module.exports = __webpack_public_path__ + "static/media/Beyonnex.c2c58dc4.svg";